<script lang="ts">
  import { onMount } from "svelte";
  import CustomListSchemaDropdown from "../../components/Form/Fields/Dropdown/CustomListSchemaDropdown.svelte";
  import Input from "../../components/Form/Fields/Input.svelte";
  import NumberInput from "../../components/Form/Fields/NumberInput.svelte";
  import FormField from "../../components/Form/FormField.svelte";
  import GlobalErrors from "../../components/GlobalErrors.svelte";
  import Table from "../../components/Table/Table.svelte";
  import FormLayout from "../../layout/FormLayout.svelte";
  import type { IDropdownItem } from "../../services/DTO/dropdown-item";
  import { customListValueFields } from "../../utils/TableFields/custom-list-value.fields";
  import {
    editing,
    init,
    loading,
    loadSchemaValues,
    onCreate,
    onDelete,
    onEdit,
    record,
    records,
    save,
    selectedSchema,
  } from "./settings-custom-list-values.store";

  let canSubmit = true;

  $: isNew = $record != null && $record.oid === 0;
  $: canCreate = $selectedSchema != null && $selectedSchema != 0;

  function onSchemaSelected(item: IDropdownItem) {
    if (!!item) {
      selectedSchema.set(item.oid);
      loadSchemaValues(item.oid);
    } else {
      selectedSchema.set(0);
      records.set([]);
    }
  }

  async function onSubmit() {
    await save();
    editing.set(false);
    record.set(null);
  }

  function onCancel() {
    editing.set(false);
    record.set(null);
  }

  onMount(init);
</script>

{#if $editing === false}
  <nav class="level">
    <div class="level-left">
      <div class="level-item">
        <p class="subtitle is-5">seleziona tabella</p>
      </div>

      <div class="level-item">
        <div class="field">
          <CustomListSchemaDropdown
            name=""
            filterVisible={true}
            value={$selectedSchema}
            on:select={(x) => onSchemaSelected(x.detail)}
          />
        </div>
      </div>
    </div>
  </nav>

  <GlobalErrors errors={[]} />

  <div style="padding-bottom: 2rem;">
    <Table
      loading={$loading}
      fields={customListValueFields}
      records={$records}
      pagination={null}
      createEnabled={canCreate}
      editEnabled={true}
      deleteEnabled={true}
      on:create={(_) => onCreate()}
      on:edit={(e) => onEdit(e.detail)}
      on:delete={(e) => onDelete(e.detail)}
    />
  </div>
{:else if $record != null}
  <FormLayout on:submit={onSubmit} on:cancel={onCancel} {canSubmit} {isNew}>
    <FormField usageHelp="descrizione visibile (200 caratteri)">
      <Input
        name="Descrizione"
        placeholder="descrizione"
        required={true}
        maxlength={200}
        bind:value={$record.description}
      />
    </FormField>

    <FormField
      usageHelp="ordine di visualizzazione (numerico). I valori vengono ordinati prima per ordine di visualizzazione e poi, a parità di ordine, per descrizione"
    >
      <NumberInput
        name="Ordine di Visualizzazione"
        placeholder="ordine visualizzazione"
        required={true}
        bind:value={$record.displayOrder}
      />
    </FormField>
  </FormLayout>
{/if}
